// extracted by mini-css-extract-plugin
export var body = "_kp-0";
export var sectionHeader = "_kp-4";
export var shortcutColumns = "_kp-2";
export var shortcutList = "_kp-1";
export var shortcutSection = "_kp-3";